import { render, staticRenderFns } from "./SupplierPayments.vue?vue&type=template&id=3191b84e&lang=pug&"
import script from "./SupplierPayments.vue?vue&type=script&lang=js&"
export * from "./SupplierPayments.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPayments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports